/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import _ from 'lodash';
import moment from 'moment';
import router from '@/router';

import ConfigCollection from '@/classes/ConfigCollection';

// initial state
const state = {
  sessions: [],
  showSelectPerceptronDialog: false,
  // isChips: false
};

// getters
const getters = {
  getSessionById: state => id => {
    return _.find(state.sessions, s => s.id === id);
  },
  activeList: state => {
    const list = _.filter(state.sessions, m => m.status !== 'closed');
    return _.sortBy(list, s => -moment(s.date, 'DD MMMM YYYY  HH:mm').format('x'));
  },
  archiveList: state => {
    const list = _.filter(state.sessions, m => m.status === 'closed');
    return _.sortBy(list, s => -moment(s.date, 'DD MMMM YYYY  HH:mm').format('x'));
  },
  chipsList: state => {
    // if (!state.isChips) return [];

    const data = _.filter(state.sessions, m => m.status === 'closed');
    const list = _.sortBy(data, s => -s.dateX)
      .filter(el => !!el.headline)
      .slice(0, 100);

    const obj = {};
    // const arr = [];
    list.map(({ headline }) => {
      const key = headline.trim().replace(/(s)+/gi, '');
      obj[key] = obj[key] || 0;
      obj[key]++;
      return key;
    });

    const arr = _.map(obj, (k, val) => ({ n: k, text: val }));
    const sorted = _.sortBy(arr, el => -el.n);

    // console.log('uniq:', arr, obj, sorted.slice(0, 10));
    return sorted.slice(0, 25);
  },
};

// actions
const actions = {
  async createNewSession({ commit, rootState, rootGetters, dispatch }) {
    let uiChannel = rootGetters['uiChannel/getUiChannel'] || 'built-in-chat';

    window.$socket.emit('/create/Session', { uiChannel }, session => {
      commit('language/setSessionLanguage', session.language, { root: true });
      router.push(`/s/${session.id}`);
      commit('setDialogVisible', false);
    });
  },
  setSessionList({ commit }, sessions) {
    commit('setList', sessions);
  },
  setDialogVisible({ commit }, isVisible) {
    commit('setDialogVisible', isVisible);
  },
  addSession({ commit }, session) {
    commit('addSession', session);
  },
  editSession({ commit, rootState, state }, session) {
    const s = _.find(state.sessions, item => item.id === session.id);

    if (s && session.state === 'closed' && s.status !== 'closed') {
      commit('inputMessage', { id: session.id, message: '' });
    }

    commit('editSession', session);

    if (rootState.route && rootState.route.params && session.id === rootState.route.params.id) {
      commit('sessionView/setSession', session, { root: true });
    }
  },

  findById: ConfigCollection.actions.findById,
  async getChatChips({ dispatch, commit }) {
    let value = false;
    try {
      const conf = await dispatch('findById', { id: 'chatChips' });
      if (conf.data) value = JSON.parse(conf.data.value);
    } catch (e) {}
    commit('setChatChips', value);
  },

  async getValueById({ dispatch }, id) {
    if (!id) throw new Error(`id is required`);

    const item = await dispatch('findById', { id: id, __native: true });

    let res;

    if (item && item.data && item.data.value) {
      try {
        res = JSON.parse(item.data.value);
      } catch (e) {
        res = item.data.value;
      }
    } else {
      throw new Error(`Config ${id} isn't found`);
    }

    return res;
  },
};

// mutations
const mutations = {
  addSession(state, session) {
    state.sessions.push({
      id: session.id,
      status: session.state,
      date: moment(session.createdAt).format('DD MMMM YYYY  HH:mm'),
      headline: session.title,
    });
  },
  editSession(state, session) {
    const index = _.findIndex(state.sessions, s => s.id === session.id);
    const newSession = {
      id: session.id,
      status: session.state,
      date: moment(session.createdAt).format('DD MMMM YYYY  HH:mm'),
      headline: session.title,
    };
    state.sessions[index] = newSession;
    state.sessions = [...state.sessions];
  },
  setList(state, list) {
    state.sessions = list.map(s => ({
      id: s.id,
      headline: s.title,
      date: moment(s.createdAt).format('DD MMMM YYYY  HH:mm'),
      status: s.state,
    }));
  },
  inputMessage(state, { id, message }) {
    const sessionListId = _.findIndex(state.sessions, item => item.id === id);
    if (sessionListId >= 0) {
      state.sessions[sessionListId].inputMessage = message;
    }
  },
  setDialogVisible(state, isVisible) {
    state.showSelectPerceptronDialog = isVisible;
  },
  setChatChips(state, value) {
    state.isChips = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
